import * as ScrollAreaPrimitive from '@radix-ui/react-scroll-area';
import { cn } from './cn';

export interface ScrollAreaProps {
  children: React.ReactNode;
  className?: string;
}

export const ScrollArea = ({ children, className }: ScrollAreaProps) => (
  <ScrollAreaPrimitive.Root
    className={cn('relative overflow-hidden', className)}
  >
    <ScrollAreaPrimitive.Viewport className="h-full w-full rounded-[inherit]">
      {children}
    </ScrollAreaPrimitive.Viewport>
    <ScrollAreaPrimitive.Scrollbar
      orientation="vertical"
      className="flex select-none touch-none p-0.5 transition-colors w-2"
    >
      <ScrollAreaPrimitive.Thumb className="relative flex-1 rounded-full bg-[var(--divider-strong)]" />
    </ScrollAreaPrimitive.Scrollbar>
  </ScrollAreaPrimitive.Root>
);
